import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import Button from '../../../../Button'
import { LoaderListItem } from '../../../../ListItem'
import { SelectDropdownEmpty } from '../../../../Select'
import {
  QA_NAME_VIEWING_FORM_NO_SLOTS_ACTION,
  VIEWING_FORM_FIELD_NAME,
  VIEWING_FORM_TIME_SOURCE,
} from '../../RentalPortalViewingFormModal.constants'

import * as styles from './ViewingFormSlotSelectDropdownEmpty.module.css'

function ViewingFormSlotSelectDropdownEmpty({
  className = styles.ViewingFormSlotSelectDropdownEmpty,
  isLoading,
}) {
  const { t } = useTranslation()

  const { setFieldValue } = useFormikContext()

  function handleClickCustomTime() {
    setFieldValue(
      VIEWING_FORM_FIELD_NAME.timeSource,
      VIEWING_FORM_TIME_SOURCE.adHoc
    )

    setFieldValue(VIEWING_FORM_FIELD_NAME.slot, null)
  }

  return isLoading ? (
    <LoaderListItem className={className} />
  ) : (
    <div className={className}>
      <SelectDropdownEmpty
        className={styles.message}
        text={t('RentalPortal.ViewingFormNoSlotsKey')}
      />
      <Button.Text
        className={styles.action}
        qaName={QA_NAME_VIEWING_FORM_NO_SLOTS_ACTION}
        text={t('RentalPortal.ViewingFormTimeAdHocKey')}
        onClick={handleClickCustomTime}
      />
    </div>
  )
}

export default ViewingFormSlotSelectDropdownEmpty
